import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/leads_/details/$leadId/')({
    beforeLoad: ({ params }) => {
        throw redirect({
            params: { customerTab: 'personal-data', leadId: params.leadId },
            replace: true,
            search: true,
            to: '/leads/details/$leadId/customer-data/$customerTab',
        });
    },
});
